import appLogo from '../../assets/logo/app-logo.svg'
import { WelcomeText } from './Login'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Input from '../../components/input/Input'
import Button from '../../components/button/Button'
import Typography from '../../components/typography/Typography'
// import { Typography } from '@mui/material';
import validateField from '../../utility/validation'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { setUserData, setUserEmail } from '../../store/slice/auth/authenticationSlice'
import { toast } from 'react-toastify'
import forgotSvg from '../../assets/icons/forgot.svg'
import { UI_CONSTANT } from '../../utility/constants'

function ForgotPasswordInput() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [pageMode, setPageMode] = useState('')
  const { forgotEmail } = useSelector((state) => state.auth) || {}
  const [load, setLoad] = useState(false)
  const [isFormValid, setIsFormValid] = useState(false)
  const [formData, setFormData] = useState({
    email: '',
  })
  const [blur, setBlur] = useState(false)

  const [errors, setErrors] = useState({})
  const hasErrors = Object.values(errors).some((error) => error)

  const handleChange = (e) => {
    const { name, value } = e.target
    setBlur(false)
    // Validate the field value
    const error = validateField(name, value)
    // Update the form data and errors state
    setFormData({
      ...formData,
      [name]: value,
    })
    setErrors({
      ...errors,
      [name]: error,
    })
  }

  const handleBlur = (e) => {
    setBlur(true)
    const { name, value } = e.target
    const error = validateField(name, value)
    setErrors({
      ...errors,
      [name]: error,
    })
  }
  const handleForgotPassword = async () => {
    const email = formData.email
    try {
      setLoad(true)
      // eslint-disable-next-line no-undef
      const response = await axios.post(`${process.env.REACT_APP_LIVE_URL}/auth/forgot-password`, { email })
      if (response?.status == 200) {
        dispatch(setUserEmail('emailSent'))
        dispatch(setUserData(response.data))
        setLoad(false)
      }
    } catch (error) {
      setLoad(false)
      toast.error(error.response.data.message, {
        className: 'custom-toast-error',
        progressStyle: { background: '#C53C43' },
      })
    }

    // dispatch(forgotPassword({ email, navigate, setPageMode }))
  }

  const handleBackLogin = () => {
    setPageMode('password')
    navigate('/login-email', { replace: true })
  }
  useEffect(() => {
    // Check if both password fields are not empty
    setIsFormValid(formData.email.trim() !== '')
  }, [formData.email])

  const handleEnterClick = (e) => {
    if (e.key === 'Enter' || e.keyCode === 13) {
      handleForgotPassword()
    }
  }

  return forgotEmail === 'emailSent' ? (
    <div className='wrapper'>
      <div className='container flex justify-center align-center'>
        <div className='section logo-section flex justify-center align-center'>
          <div className='container'>
            <img src={appLogo} alt='App Logo' />
          </div>
        </div>
        <div className='section login-section flex justify-center align-center'>
          <div className='container flex flex-column justify-evenly '>
            <WelcomeText title={forgotEmail === 'emailSent' ? "Password changed" : 'Forgot Password'} message='Login in to your account below' hideHandIcon />
            <div className='input-wrapper flex flex-column justify-center align-center'>
              <div className='pass-forgot flex flex-column justify-end'>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <img src={forgotSvg} alt='forgot' style={{ width: '80%' }} />
                </div>
                <div style={{ marginTop: '40px' }}>
                  <Typography textColor='red' textWeight='400' textAlign='center' justify='center'>
                    {UI_CONSTANT.LOGIN.LOGIN_EMAIL_MSG}
                  </Typography>
                </div>
              </div>
            </div>
            <div className='button-wrapper flex flex-column justify-center align-center'>
              <Button onClick={handleBackLogin} customClassName={'otp-login'}>
                <Typography textColor='white' textType='login-button' textWeight='700'>
                  {UI_CONSTANT.LOGIN.BACK_TO_LOGIN}
                </Typography>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className='wrapper'>
      <div className='container flex justify-center align-center'>
        <div className='section logo-section flex justify-center align-center'>
          <div className='container'>
            <img src={appLogo} alt='App Logo' />
          </div>
        </div>
        <div className='section login-section flex justify-center align-center'>
          <div className='container flex flex-column justify-evenly '>
            <WelcomeText
              title='Forgot Password'
              message='Enter email to receive instructions for reset password'
              hideHandIcon
            />
            <div className='input-wrapper flex flex-column justify-center align-center'>
              <div className='pass-forgot flex flex-column justify-end'>
                <Input
                  placeholder='Enter your Email'
                  icon='email'
                  name='email'
                  value={formData.email}
                  error={errors.email}
                  onBlur={(e) => handleBlur(e)}
                  blur={blur}
                  onChange={handleChange}
                  onKeyDown={handleEnterClick}
                />
              </div>
            </div>
            <div className='button-wrapper flex flex-column justify-center align-center'>
              <Button
                onClick={handleForgotPassword}
                disabled={!isFormValid || hasErrors}
                customClassName={'otp-login'}
                disabledBgColor={'#ee4e56'}
              >
                <Typography textColor='white' textType='login-button' textWeight='700'>
                  {load ? UI_CONSTANT.LOADING : UI_CONSTANT.SEND}
                </Typography>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ForgotPasswordInput
